import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { GetMonitoredObject } from '../Api/getData';

const FilterObject = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // Ambil nilai dari searchParams atau gunakan nilai default
    const paramsKodeCabang = (searchParams.get("KodeCabang") || "SGM") ?? "SGM";
    const paramsShipCode = (searchParams.get("ShipCode") || "G2008") ?? "G2008";

    // Inisialisasi state dengan nilai dari searchParams
    const [selectedValue, setSelectedValue] = useState({
        KodeCabang: paramsKodeCabang,
        ShipCode: paramsShipCode,
    });

    const [dataObject, setDataObject] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Fetch data saat modal dibuka
    useEffect(() => {
        const fetchDataObject = async () => {
            try {
                const response = await GetMonitoredObject({
                    AccountId: paramsKodeCabang,
                    ObjectCode: paramsShipCode,
                });
                // console.log(response);
                // const ShipCode = response?.Ship.filter((item) => item.KodeCabang === selectedValue.KodeCabang);
                // const payload = {
                //     ...response,
                //     Ship: ShipCode
                // }
                setDataObject(response);
                // console.log(ShipCode);
            } catch (error) {
                console.log(error);
            }
        };
        if (isModalOpen) {
            fetchDataObject();
        }
    }, [paramsKodeCabang, isModalOpen, selectedValue.KodeCabang]);

    // Update selectedValue jika searchParams berubah
    useEffect(() => {
        setSelectedValue({
            KodeCabang: paramsKodeCabang,
            ShipCode: paramsShipCode,
        });
    }, [paramsKodeCabang, paramsShipCode]);

    const cabang = dataObject?.Cabang || [];
    const ship = dataObject?.Ship || [];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSelectedValue((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        if (selectedValue.KodeCabang && selectedValue.ShipCode) {
            const KodeCabang = dataObject.Ship.find(
                (item) => item.ShipCode === selectedValue.ShipCode
            )?.KodeCabang;
            const dataCabang = dataObject.Cabang.find(
                (item) => item.KodeCabang === KodeCabang
            ) ?? dataObject?.Cabang[0];
            const dataShip = dataObject.Ship.find(
                (item) => item.ShipCode === selectedValue.ShipCode
            ) ?? dataObject?.Ship[0];

            const data = {
                ...dataCabang,
                ...dataShip,
            };

            // Simpan ke localStorage
            localStorage.setItem('Filter', JSON.stringify(data));

            // Dispatch custom event to notify other components
            window.dispatchEvent(new CustomEvent('filterUpdated'));

            // Navigasikan dengan query params
            const queryParams = new URLSearchParams({
                KodeCabang: data.KodeCabang,
                ShipCode: data.ShipCode,
            }).toString();
            navigate(`?${queryParams}`);

            setIsModalOpen(false);
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Button
                icon={<SearchOutlined />}
                onClick={showModal}
                iconPosition="end"
                className="w-full bg-white/10 hover:bg-white/20 border-white/20 text-white hover:text-white"
            >
                Filter Vessel
            </Button>

            <Modal
                title="Filter"
                centered
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                width={1000}
            >
                <div className="flex flex-col lg:flex-row gap-2 w-full">
                    {/* <div className="w-full">
                        <label className="block mb-2 text-xl font-medium text-gray-900">Branch</label>
                        <select
                            name="KodeCabang"
                            value={selectedValue.KodeCabang || ''}
                            onChange={handleChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-xl rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        >
                            {cabang.map((item) => (
                                <option key={item.KodeCabang} value={item.KodeCabang}>
                                    {item.NamaCabang}
                                </option>
                            ))}
                        </select>
                    </div> */}

                    <div className="w-full">
                        <label className="block mb-2 text-xl font-medium text-gray-900">Ship</label>
                        <select
                            name="ShipCode"
                            value={selectedValue.ShipCode || ''}
                            onChange={handleChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-xl rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        >
                            {ship.map((item) => (
                                <option key={item.ShipCode} value={item.ShipCode}>
                                    {item.ShipName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default FilterObject;